import styled from 'styled-components'
import theme from '../theme'

export default styled.div`
  font-size: 0.8rem;
  text-transform: uppercase;
  text-align: center;
  color: ${theme.textOff};
  font-family: ${theme.font.mono};
  font-weight: normal;
  margin-top: .2rem;
`;
